var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ShieldTickSvg from './shield-tick.icon.svg';
export const ShieldTickIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: ShieldTickSvg }));
_react_refresh_temp_1 = ShieldTickIcon;
$RefreshReg$(_react_refresh_temp_1, "ShieldTickIcon");
